import React, { useState } from 'react';
import { Box, Drawer } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles( theme => ({
  buttonCollapse: {
    [theme.breakpoints.up("md")]: {
      display: "none"
    },
  },
  drawerClose:{
    color: '#fff',
    marginRight: 0,
    marginLeft: 'auto',
  },
  drawer: {
    minWidth: '360px',
  },
  drawerPaper: {
    // backgroundColor: colors.appBarMenu.bg,
    backgroundImage: 'linear-gradient(to right, #af0000, #670000)',
    color: '#fff',
    minWidth: '360px'
  },
  menuIcon: {
    color: '#fff'
  }
}));
const MobileAppbar = (props) => {
  const classes = useStyles();
  const [drawerState, setDrawerState] = useState(false);

  const toggleDrawer = (event) => {
    setDrawerState(!drawerState)
  };

  return(
    <Box className={classes.buttonCollapse}>
      <IconButton className={classes.menuIcon} onClick={(e) => toggleDrawer(e)}>
        <MenuIcon />
      </IconButton>
      <Drawer
        className={classes.paper}
        classes={{
          paper: classes.drawerPaper
        }}
        anchor="right"
        open={drawerState}
        onClose={(e) => toggleDrawer(e) }
      >
        <IconButton className={classes.drawerClose} onClick={(e) => toggleDrawer(e)}>
          <CloseIcon />
        </IconButton>
        {props.children}
      </Drawer>
    </Box>
  )
}

export default MobileAppbar;